import React, { FC } from 'react';

import { RootState, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    button: ['shop now - button'],
    sub_button: ['close - button']
  }
};

const ImageBottomSheetTracking: FC = () => {
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .modal_wrapper {
      width: 100%;
      height: 17rem;
      padding: 1rem 0 1.5rem 0;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;

      position: absolute;
      bottom: 0;

      overflow: hidden;
    }

    .close_btn {
      width: 100%;
      height: 24px;
      display: flex;
      justify-content: end;
    }

    .contents_box {
      height: calc(100% - 2rem);
      margin-top: 0.5rem;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .contents_box .title {
      width: 100%;
      height: 4rem;

      display: flex;
      align-items: center;
    }
    .contents_box .title_inner {
      height: auto;
      max-height: 3.5rem;
    }

    .contents_box .sub_title {
      width: 100%;
      height: 3rem;
    }

    .btn_wrapper {
        height: 38.79px;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="modal_wrapper">
          <div className="close_btn tracking_center">
            <EditTracking value={tracking?.sub_button?.[0]} type="sub_button" />
          </div>
          <div className="contents_box">
            <div>
              <div className="title">
                <div className="title_inner" />
              </div>
              <div className="sub_title" />
            </div>
            <div className="btn_wrapper tracking_center">
              <EditTracking value={tracking?.button?.[0]} type="button" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImageBottomSheetTracking;
